var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ready)?_c('div',{attrs:{"id":"chart"}}):_c('center',[_c('b-spinner',{attrs:{"type":"grow","label":"Spinning"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }